import { Radio, RadioGroup } from '@headlessui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline'

export function SelfAssessmentStep({
  name,
  selfAssessmentEnabled,
  setSelfAssessmentEnabled,
}: {
  name: string
  selfAssessmentEnabled: boolean | null
  setSelfAssessmentEnabled: (value: boolean) => void
}) {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Self Assessment</h2>
      <p className="mb-4">
        {name ? `${name}, do` : 'Do'} you make a self assessment tax return each
        year?
      </p>
      <p className="text-sm text-gray-600 mb-4">
        Self Assessment is how HMRC collects Income Tax from self-employed
        individuals, business partners, or those with additional income. If you
        answer 'Yes', we'll add key tax deadlines to your calendar to help you
        stay on track.
        <a
          href="https://www.gov.uk/self-assessment-tax-returns"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline ml-1"
        >
          Learn more
        </a>
      </p>
      <RadioGroup
        value={selfAssessmentEnabled}
        onChange={setSelfAssessmentEnabled}
      >
        <Radio value={true}>
          {({ checked }) => (
            <div
              className={`${checked ? 'bg-blue-50 border-blue-500' : 'bg-white'} border rounded-md p-4 flex items-center mb-2 cursor-pointer`}
            >
              <QuestionMarkCircleIcon
                className={`${checked ? 'text-blue-500' : 'text-gray-400'} w-6 h-6 mr-2`}
              />
              <span>Yes, I do</span>
            </div>
          )}
        </Radio>
        <Radio value={false}>
          {({ checked }) => (
            <div
              className={`${checked ? 'bg-blue-50 border-blue-500' : 'bg-white'} border rounded-md p-4 flex items-center cursor-pointer`}
            >
              <QuestionMarkCircleIcon
                className={`${checked ? 'text-blue-500' : 'text-gray-400'} w-6 h-6 mr-2`}
              />
              <span>No, I don't</span>
            </div>
          )}
        </Radio>
      </RadioGroup>
    </div>
  )
}
